import { render, staticRenderFns } from "./MoreResultsBtn.vue?vue&type=template&id=4562243e&"
import script from "./MoreResultsBtn.vue?vue&type=script&lang=js&"
export * from "./MoreResultsBtn.vue?vue&type=script&lang=js&"
import style0 from "./MoreResultsBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports